/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-09-05 15:35:54
 **/

import DummyStream from "./dummystream";

class MediaUtilityStatic {
	public close(stream: MediaStream | null) {
		if (stream) {
			for (const track of stream.getTracks()) {
				track && track.stop();
			}
			stream = null;
		}
	}

	public create_dummy_stream() {
		return new DummyStream().create();
	}
}
const MediaUtility = Object.freeze(new MediaUtilityStatic());
export default MediaUtility;
